/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";

import AgentDetail from "./AgentDetail";

/* Render AgentDetail app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<AgentDetail {...props} />, document.getElementById("react"));
}
render(window.reactProps);
